<template>
	<v-app id="inspire">
		<v-content>
			<v-container fluid fill-height>
				<v-layout align-center justify-center style="text-align: center;">
					<v-flex xs12 sm8 md4>
						<h1 class="font-weight-light">Service Scheduler | Branch</h1>
						<v-form>
							<v-layout>
								<v-flex xs12>
								<div id="firebaseui-auth-container"></div>
								</v-flex>
							</v-layout>
							<v-layout class="mt-3">
								<v-flex xs11 offset-xs1>
								<p></p>
								</v-flex>
							</v-layout>
						</v-form>
					</v-flex>
				</v-layout>
			</v-container>
		</v-content>
	</v-app>
</template>

<script>
import firebase from "firebase"
import * as firebaseui from "firebaseui"
import { db } from "../main"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { config } from "../firebaseConfig"
import { mapGetters, mapActions, mapState } from "vuex"
import router from '../router'
import moment from 'moment'
import { stage } from '../../appConfig'

export default {
    mounted() {
        let self = this
        let uiConfig = {
            signInOptions: [{
                provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                    scopes: config.scopes,
                    customParameters: {
                        hd: "scinnova.com.ph"
                    }
            }],
            
            callbacks: {
                signInSuccessWithAuthResult: function(authResult, redirectUrl) {
                    firebase.auth().onAuthStateChanged(function(user) {
                        if (user) {
                            let googleUser = {
                                uid: user.uid,
                                email: user.email,
                                displayName: user.displayName,
                                photoURL: user.photoURL,
                            }
                            self.$store.dispatch("setUser", googleUser).then(() => {
                                user.getIdToken().then(function(accessToken) {
                                    self.$store.dispatch("setToken", accessToken).then(() => {
                                        self.$store.dispatch("setAuth", true).then(() => {
                                            self.loginFromInvitation()
                                        }).catch(error => console.log(error))	
                                    })
                                })
                            })
                        } 
                    }, function(error) {
                        console.log(error)
                    })
                    return false
                }
            }
        }
        let ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth())
        ui.start("#firebaseui-auth-container", uiConfig)
    },
    
    methods: {
        updateDispatchRole(user,data) {
            let self = this
            db.collection("Users"+self.$stage).doc(user.uid)
            .update({
                role: "admin",
                assign: `${data.branchCode}_${data.branch}`,
                assignId: data.branchId
            }).then(function(){
                db.collection("Users"+self.$stage).doc(user.uid)
                    .onSnapshot(function(doc) {
                        self.$store.dispatch("setRole", data.role).then(() => {
                            window.location.href = "/transactions"
                        }).catch(error => console.log(error))
                    })
                console.log("User role updated")
            })
        },

        loginFromInvitation() {
            let self = this
            db.collection("branchUsers"+self.$stage).doc(self.user.email)
            .get().then(function(doc) {
                if(doc.data()) {
                    if(doc.data().status == "pending") {
                        db.collection("branchUsers"+self.$stage).doc(self.user.email)
                        .update({
                            status: "active",
                            activationDate: moment().format('MMMM Do YYYY, h:mm:ss a'),
                        }).then(function(){
                            firebase.auth().onAuthStateChanged(function(user) {
                                db.collection("Users"+self.$stage).doc(user.uid)
                                .update({
                                    role: "admin",
                                    assign: `${doc.data().branchCode}_${doc.data().branch}`,
                                    assignId: doc.data().branchId
                                }).then(function(){
                                    self.updateDispatchRole(user,doc.data())
                                })
                            })
                            console.log("User invite accepted")
                        })
                    } else if (doc.data().status == "active"){
                        window.location.href = "/transactions"
                        console.log("User already accept invitation")
                    } else {
                        window.location.href = "/404"
                        console.log("User already inactive")
                    }
                } else {
                    window.location.href = "/404"
                }
                
            }).catch(function(error) { console.log("Error getting from invitation:", error)})
		}
    },

    computed: {
		...mapGetters(["auth","user"])
    },
    
    beforeDestroy() {
		this.ui.delete()
	}
}
</script>